import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Globe } from 'lucide-react';

export const LanguageToggle: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <button
      onClick={() => setLanguage(language === 'en' ? 'zh' : 'en')}
      className="fixed bottom-6 right-6 flex items-center gap-2 bg-white/90 backdrop-blur-md border border-slate-200 px-4 py-3 rounded-full shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all text-slate-600 text-sm font-bold z-[1000] group"
    >
      <Globe size={18} className="text-primary group-hover:rotate-12 transition-transform" />
      <span>{language === 'en' ? '中文' : 'English'}</span>
    </button>
  );
};
